import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useToastr from 'helpers/toastr'; // Adjust the path accordingly
import { loginUser, sendOtp, socialLoginRequest, getAccessToken } from "store/actions";
import Loader from "Component/Common/Loader";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
// import { isKycValid } from "helpers/constants";
import { useSuccessMsg } from "helpers/custom-hooks";
import AppleLogin from 'react-apple-login';

import { useTranslation } from 'react-i18next';
import axios from "axios";
import jwtDecode from "jwt-decode";

const Signin = () => {
  const toastr = useToastr();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState("password");
  const { t } = useTranslation();
  const { loading } = useSelector((state) => state?.Login);
  const [fields, setFields] = useState({
    role: "USER",
    email: "",
    password: ""
  })


  /**
      * handled the input changes set to the state
      */
  const handleChange = (name) => (e) => {
    setFields(prev => ({ ...prev, [name]: e.target.value }));

  }

  /**
    * Used for user authentication OAuth
    */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (fields.email === "" || fields.password === "") {
      return toastr.error(t('all_fields_required'), {});
    }

    const loginCallback = (loginResponse) => {
      if (loginResponse.status === "success") {
        const otpCallback = (otpResponse) => {
          if (otpResponse.status === "success") {
            navigate('/email-verification', {
              state: {
                email: fields?.email,
                role: fields?.role,
                path: "signin"
              }
            });
            toastr.success(t('code-sent') + otpResponse?.data?.email);
          } else {
            toastr.error(otpResponse.message);
          }
        };

        dispatch(sendOtp({ role: fields?.role, email: fields?.email }, otpCallback));
      } else {
        toastr.error(loginResponse.message);
      }
    };

    dispatch(loginUser(fields, loginCallback));
  };


  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };


  /**
   * Used for user authentication using Google OAuth
   */
  const responseGoogle = (response) => {
    const tokenInfoCallback = (tokenResponse) => {
      if (tokenResponse.status === 200) {
        const googleUserData = tokenResponse?.data;
        const info = {
          email: googleUserData?.email,
          fname: googleUserData?.given_name,
          kyc: {
            fname: googleUserData?.given_name,
            lname: googleUserData?.family_name,
            email: googleUserData?.email,
          },
          lname: googleUserData?.family_name,
          role: "USER",
          type: "google",
          google_id: googleUserData?.sub,
        };

        const socialLoginCallback = (socialLoginResponse) => {
          if (socialLoginResponse.status === "success") {
            sendOtpAndNavigate(googleUserData?.email);
          } else {
            toastr.error(socialLoginResponse.message);
          }
        };

        dispatch(socialLoginRequest(info, socialLoginCallback));
      } else {
        toastr.error(t('something_wrong'));
      }
    };

    dispatch(getAccessToken(response?.access_token, tokenInfoCallback));

    const sendOtpAndNavigate = (googleAuthEmail) => {
      const sendOtpCallback = (otpResponse) => {
        if (otpResponse.status === "success") {
          navigate('/email-verification', {
            state: {
              email: googleAuthEmail ? googleAuthEmail : fields?.email,
              role: fields?.role,
              path: "signin",
            },
          });
          toastr.success(t('code-sent') + otpResponse?.data?.email);
        } else {
          toastr.error(otpResponse.message);
        }
      };

      dispatch(sendOtp({ role: fields?.role, email: googleAuthEmail ? googleAuthEmail : fields?.email   }, sendOtpCallback));
    };
  };


  const handleBack = () => {
    navigate('/');
  }


  const login = useGoogleLogin({
    onSuccess: tokenResponse => responseGoogle(tokenResponse),
  });


  const handleKeyDown = (e) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }

  }

  /**
   * Used for user authentication using Apple OAuth
   */
  const appleResponse = (response) => {
    const { authorization } = response || {};
    if (authorization) {
      const appleToken = authorization.id_token;
      const decoded = jwtDecode(appleToken);

      const socialLoginCallback = (socialLoginResponse) => {
        if (socialLoginResponse.status === "success") {
          sendOtpAndNavigate(decoded?.email);
        } else {
          toastr.error(socialLoginResponse.message);
        }
      };

      const info = {
        email: decoded?.email ?? "",
        fname: decoded?.given_name ?? "",
        kyc: {
          fname: decoded?.given_name ?? "",
          lname: decoded?.family_name ?? "",
          email: decoded?.email ?? "",
        },
        lname: decoded?.family_name ?? "",
        role: "USER",
        type: "apple",
        apple_id: decoded?.sub ?? ""
      };

      dispatch(socialLoginRequest(info, socialLoginCallback));
    }
  };

  const sendOtpAndNavigate = (appleEmail) => {
    const sendOtpCallback = (otpResponse) => {
      if (otpResponse.status === "success") {
        navigate('/email-verification', {
          state: {
            email: appleEmail ? appleEmail : fields?.email,
            role: fields?.role,
            path: "signin"
          }
        });
        toastr.success(t('code-sent') + otpResponse?.data?.email);
      } else {
        toastr.error(otpResponse.message);
      }
    };

    dispatch(sendOtp({ role: fields?.role, email: appleEmail ? appleEmail : fields?.email   }, sendOtpCallback));
  };



  /**
    * return will render the Login UI in the browser
    */
  return (
    <section className="common_sign_main sign_in p-3">
      {loading && <Loader />}

      <Container fluid>
        <div className="common_sign_inner">


          <Row>
            <Col lg={5} md={6} sm={12} className="order-2 order-lg-1">


              <div className="left_form_part">


                <div className="arrow_with_head">
                  <svg role="button" onClick={handleBack} width="30" height="30" class="w-6 h-6 text-gray-800 dark:text-white mb-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4" />
                  </svg>
                  <h3 className="sign_head mobile_auth_head">{t('login_into')} {t('your_account')}</h3>

                </div>

                <Form className="form_sign_inout" >
                  <h3 className="sign_head desktop_auth_head">{t('login_into')} <br></br>{t('your_account')}</h3>



                  <Row>
                    <Col lg={12} sm={12}>
                      <FormGroup>
                        <Label for="exampleEmail">{t('email')} <span className="col_red"><sup>*</sup></span></Label>
                        <Input
                          type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder={t('email_placeholder_text')}
                          onChange={handleChange("email")}
                          onKeyDown={handleKeyDown}
                          title={t('fill_this_field')}


                        />
                      </FormGroup>
                    </Col>

                    <Col lg={12} sm={12}>
                      <FormGroup className="position-relative">
                        <Label for="examplePassword">{t('password')} <span className="col_red"><sup>*</sup></span></Label>
                        <Input
                          type={passwordType}
                          name="password"
                          id="examplePassword"
                          placeholder={t('password_placeholder')}
                          onChange={handleChange("password")}
                          onKeyDown={handleKeyDown}
                          title={t('fill_this_field')}



                        />
                        {passwordType === "password" ?
                          <Button className="eye_btn" onClick={togglePassword}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path fill="#9BA1B3" d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z" /></svg>

                          </Button> :
                          <Button className="eye_btn" onClick={togglePassword}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25"
                              height="25" viewBox="0 0 256 256"><path fill="#9BA1B3" d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34" /></svg>
                          </Button>

                        }
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="remember_mer">
                    <Link to="/verify-email">{t('forgot_password')}</Link>
                  </div>

                  <Button onClick={handleSubmit} className="btn_sign_in btn_theme w-100 mt-4" type="submit">{t('logIn')}</Button>

                  <div className="or_col position-relative text-center my-3">
                    <p>{t('or')}</p>
                  </div>

                  <Button className="btn_sign_in w-100 mt-2 mb-4 d-flex align-items-center justify-content-center" onClick={login}>
                    <span className="me-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 256 262"><path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" /><path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" /><path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" /><path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" /></svg>
                    </span>
                    {t('google_signin')}</Button>


                  <div className="btn_sign_in w-100 mt-2 mb-4 d-flex align-items-center justify-content-center"
                  >

                    <AppleLogin
                      clientId="com.soorx"
                      redirectURI="https://soorx.com"
                      usePopup={true}
                      callback={appleResponse}
                      scope="email name"
                      responseMode="query"
                      render={renderProps => (
                        <Button className="btn_sign_apple w-100 mt-2 mb-4 d-flex align-items-center justify-content-center"
                          onClick={renderProps.onClick}
                        >
                          <span className="me-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 16 16"><path fill="#fff" d="M10.74 1.01s-1.08.01-2 1.03c-.92 1.01-.78 2.17-.76 2.2c.02.03 1.31.08 2.13-1.1c.82-1.18.66-2.09.63-2.13m2.86 10.27c-.04-.08-2-1.08-1.82-2.99c.18-1.92 1.44-2.44 1.46-2.5c.02-.06-.51-.69-1.08-1.01a3.08 3.08 0 0 0-1.35-.38c-.09 0-.42-.08-1.08.1c-.44.12-1.42.52-1.7.53c-.27.02-1.08-.46-1.95-.58c-.56-.11-1.15.11-1.57.29c-.42.17-1.23.66-1.79 1.96c-.56 1.3-.27 3.35-.06 3.99c.21.64.54 1.68 1.1 2.45c.5.86 1.15 1.46 1.43 1.66c.27.2 1.05.34 1.59.06c.43-.27 1.21-.42 1.52-.41c.31.01.91.13 1.54.47c.49.17.96.1 1.42-.09c.47-.19 1.14-.93 1.93-2.41c.3-.69.44-1.06.41-1.12Z" /></svg>                          </span>
                          {t('apple_signin')}</Button>

                      )}
                    />
                  </div>
                  <div className="dont_have_accoutn text-center pt-4">
                    <p>{t('dont_have_account')}
                      <Link to="/signup"> {t('signup_here')}.</Link>
                    </p>
                  </div>
                </Form>
              </div>

            </Col>

            <Col lg={7} md={6} sm={12} className="order-1 order-lg-2">

              <div className="right_gradient_part position-relative">

                <Link to="/" className="logo">
                  <img src="images/logo.svg" alt="logo" className="img-fluid" />
                </Link>

                <div className="signingimg_bottom">
                  <img
                    src="/images/signinimg.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>

                <div className="right_gradient_text">
                  <h4>{t('track_crypto')}</h4>
                  <p>
                    {t('login_ispublish')}
                  </p>
                </div>
              </div>

            </Col>
          </Row>
        </div>

      </Container>

    </section>
  );
};

export default Signin;
